export enum EmailPriority {
    Normal = 0,
    Low = 1,
    High = 2
}